

import { getAcl, ListMenu } from '../../../utils/common';

// ----------------------------------------------------------------------

const navconficCustom = [];
const navConfig = ListMenu();

navConfig.map((c, i) => {
  const acl = JSON.parse(getAcl());
  const menu = acl?.find((e) => c.namaroute === e.nama_menu && e.read === true);
  if (menu !== undefined || c.namaroute === 'logout') {
    navconficCustom.push(c);
  }

  return c;
});

export default navConfig;
